import { render, staticRenderFns } from "./insurance.vue?vue&type=template&id=40299436"
import script from "./insurance.vue?vue&type=script&lang=js"
export * from "./insurance.vue?vue&type=script&lang=js"
import style0 from "./insurance.vue?vue&type=style&index=0&id=40299436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports